// author @xys
/**
 * 制作简单的canvas 卡片
 * 二维码卡片制作制作
 * el dom元素或者dom的id
 * width,height 卡片宽高
 * multiple 比率默认1倍
 * className 最后插入dom节点内图片的class
 * success 制作完成后的回调
 */
//   els 说明
/**
 * els: {
 *  type: "img" || "text" || "roundrect" // 绘制类型
 *   // img
 *   url, // 图片路径
 *   center, 如果有该属性，则忽略x 横轴居中显示
 *   x,y, // 图片左上角的位置
 *   w,h, // 宽高
 *   round:true/false // 是否圆形展示；主要用于头像内容绘制
 *
 *   // text
 *   text,
 *   center, 如果有该属性，则忽略x 横轴居中显示
 *   x,y // 默认文字正中间
 *   textAlign, // 默认 center
 *   textBaseline, // 默认 middle
 *   color, // 默认 #000
 *   fontSize, // 默认 12
 *   weight, // 默认 normal
 *
 *   // roundrect
 *   x,y, // 图形左上角位置
 *   w,h, // 宽高
 *   r, // 圆角
 *   color,
 *   lineWidth, // 边线宽度
 *  }
 * }
 */
export const MakeCard = function (op) {
  this.c = document.createElement("canvas");
  const ctx = this.c.getContext("2d");
  this.els = op.els;
  this.el = isDOM(op.el) ? op.el : document.getElementById(op.el);
  this.multiple = op.multiple || 1;
  this.width = op.width * this.multiple;
  this.height = op.height * this.multiple;
  this.className = op.className;
  this.success = op.success;
  this.c.width = this.width;
  this.c.height = this.height;
  this.create = async function () {
    try {
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(this.width, 0);
      ctx.lineTo(this.width, this.height);
      ctx.lineTo(0, this.height);
      ctx.lineTo(0, 0);
      ctx.fillStyle = "#fff";
      ctx.fill();
      ctx.restore();
      // 遍历并给number 类型数值变换倍率
      const setM = (obj) => {
        return new Promise((res) => {
          let o = {};
          for (let k in obj) {
            if (typeof obj[k] === "number") {
              o[k] = obj[k] * this.multiple;
            } else {
              o[k] = obj[k];
            }
          }
          res(o);
        });
      };
      for (let i = 0; i < this.els.length; i++) {
        const item = await setM(this.els[i]);
        if (item.type === "img") {
          ctx.save();
          const img = await imgLoadend(item.url);
          if (item.round) {
            ctx.beginPath();
            ctx.arc(
              item.x + item.w / 2,
              item.y + item.h / 2,
              item.h / 2,
              0,
              2 * Math.PI,
              false
            );
            ctx.clip();
          }
          ctx.drawImage(
            img,
            item.center ? (this.width - item.w) / 2 : item.x,
            item.y,
            item.w,
            item.h
          );
          ctx.restore();
        } else if (item.type === "text") {
          ctx.save();
          ctx.font = `normal normal ${item.weight ? item.weight : "normal"} ${
            item.fontSize ? item.fontSize : 12 * this.multiple
          }px "微软雅黑" `;
          ctx.textAlign = item.textAlign ? item.textAlign : "center";
          ctx.textBaseline = item.textBaseline ? item.textBaseline : "middle";
          ctx.fillStyle = item.color ? item.color : "#000";
          ctx.fillText(
            item.text,
            item.center ? this.width / 2 : item.x,
            item.y
          );
          ctx.restore();
        } else if (item.type === "roundrect") {
          ctx.save();
          drawRoundRect(
            ctx,
            item.x,
            item.y,
            item.w,
            item.h,
            item.r,
            item.color,
            item.lineWidth
          );
          ctx.restore();
        }
        if (i === this.els.length - 1) {
          let base64Img = this.c.toDataURL("image/jpg");
          const _card = await imgLoadend(base64Img, this.className);
          this.el.innerHTML = "";
          this.el.appendChild(_card);
          if (typeof this.success === "function") {
            this.success();
          }
        }
      }
      let base64Img = this.c.toDataURL("image/jpg");
      const _card = await imgLoadend(base64Img, this.className);
      this.el.innerHTML = "";
      this.el.appendChild(_card);
      if (typeof this.success === "function") {
        this.success();
      }
    } catch (error) {
      console.log(error);
    }
  };
};

// 检测是否为dom
const isDOM = (item) => {
  return typeof HTMLElement === "function"
    ? item instanceof HTMLElement
    : item &&
        typeof item === "object" &&
        item.nodeType === 1 &&
        typeof item.nodeName === "string";
};
// 同步图片加载防止图片空白
const imgLoadend = (url, className = "") => {
  return new Promise((res) => {
    let img = document.createElement("img");
    img.crossOrigin = "anonymous";
    img.src = url;
    img.setAttribute("class", className);
    img.onload = () => {
      res(img);
    };
  });
};

// 绘制圆角矩形
const drawRoundRect = (ctx, x, y, w, h, r, c, lw) => {
  ctx.save();
  ctx.lineWidth = lw;
  ctx.beginPath();
  ctx.moveTo(x, y + r);
  ctx.arcTo(x, y, x + r, y, r);
  ctx.lineTo(x + w - r, y);
  ctx.arcTo(x + w, y, x + w, y + r, r);
  ctx.lineTo(x + w, y + h - r);
  ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
  ctx.lineTo(x + r, y + h);
  ctx.arcTo(x, y + h, x, y + h - r, r);
  ctx.lineTo(x, y + r);
  ctx.strokeStyle = c;
  ctx.stroke();
  ctx.restore();
};
